export default function stringify(request) {
  request.headers['x-chivox-scene'] =
    window.navigator.userAgent.match(/Electron/) && !localStorage.getItem('exetype')
      ? 2
      : 1
  return request
}



// WEBPACK FOOTER //
// ./src/axios/request_interceptors/isJF.js